export const motivoDefault = {
    "Activo": true,
    "Descripcion": "Renovacion",
    "Id": 1
}